import { PasswordField } from "components/common/form";
import { Button, Col, Form } from "react-bootstrap";
import { SignUpFormValues } from "./SignUpForm";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export type SignUpKeycloakProps = {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
    formRef: React.RefObject<HTMLFormElement>;
    values: SignUpFormValues;
    errors: any;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isInit: boolean;
    isValid: boolean;
    errorMessage: string;
};
export const SignUpKeycloak = (props: SignUpKeycloakProps) => {
    const {
        handleSubmit,
        formRef,
        values,
        errors,
        handleInputChange,
        isInit,
        isValid,
        errorMessage,
    } = props;
    return (
        <Col lg="6" sm="12" className="login-form">
            <div className="login-box-keycloak">
                <div className="login-table-keycloak">
                    <div className="login-text">
                        <h4>Complete Initial Setup</h4>
                    </div>
                    <Box
                        sx={{
                            mb: 3,
                            backgroundColor: "#F2F2F2",
                            color: "#2F3A51",
                            padding: "20px",
                            borderRadius: "10px",
                        }}
                    >
                        <Grid container spacing={2}>
                            {/* First Row */}
                            <Grid item xs={6}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    First Name
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 500 }}
                                >
                                    {values.firstName || "-"}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Last Name
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 500 }}
                                >
                                    {values.lastName || "-"}
                                </Typography>
                            </Grid>
                            {/* Second Row */}
                            <Grid item xs={12}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Email Address
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{ fontWeight: 500 }}
                                >
                                    {values.email || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Form noValidate onSubmit={handleSubmit} ref={formRef}>
                        <Box sx={{ color: "#2F3A51" }}>
                            <Typography variant="h6">
                                Password Confirmation Required
                            </Typography>
                            <Typography variant="body1">
                                For initial setup, please re-enter the same
                                password you used during account creation.
                            </Typography>
                        </Box>
                        <Form.Group className="mt-4">
                            <Form.Label>Password</Form.Label>
                            <PasswordField
                                name="password"
                                aria-label="password"
                                placeholder="Enter Password"
                                required
                                value={values.password}
                                isInvalid={!!errors.password}
                                onChange={handleInputChange}
                                autoComplete="new-password"
                                error={errors.password}
                                className="pr-5"
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Confirm Password</Form.Label>
                            <PasswordField
                                name="confirmPassword"
                                aria-label="confirmPassword"
                                placeholder="Re-enter Password"
                                required
                                value={values.confirmPassword}
                                isInvalid={!!errors.confirmPassword}
                                onChange={handleInputChange}
                                autoComplete="confirm-password"
                                error={errors.confirmPassword}
                                className="pr-5"
                            />
                        </Form.Group>

                        <Button
                            type="submit"
                            className="sign-up"
                            variant={
                                !isInit && isValid ? "primary" : "secondary"
                            }
                            disabled={isInit || !isValid}
                        >
                            FINISH SETUP
                        </Button>

                        <div className="loginf">
                            {errors.terms && <p>{errors.terms}</p>}
                            {errorMessage && <p role="alert">{errorMessage}</p>}
                        </div>
                    </Form>
                </div>
            </div>
        </Col>
    );
};
